import { useDisclosure } from '@mantine/hooks'
import React, { memo, useEffect, useState } from 'react'
import { useQuery } from 'react-query'
import { connect, useDispatch, useSelector } from 'react-redux'
import { withRouter } from 'react-router-dom'

import { api_gateway } from '../../conexoes/api.js'
import '../../css/painelDashboard/dashboard.css'
import {
  filtrosArrayBarra,
  limpadorFiltros,
  mudarFiltros,
  mudarManejador,
  realizouFiltro,
  recarregarBarraFiltragem,
  revelarBarraFiltragem
} from '../../redux/actions/index'
import { DispositivosService } from '../../services/http/dispositivos.service.js'
import { useGlobal } from '../../stores/useGlobal.js'
import ConversorBytes from '../../utils/conversorBytes.js'
import {
  corDash as cor,
  DashArrayCoresDefault,
  handleGetColorByIdx
} from '../../utils/dashboard.js'
import decryptJWT from '../../utils/decryptJWT.js'
import {
  formatarMilhar,
  formatarMilharSemDecimais
} from '../../utils/formatarMilhar.js'
import { isPortal } from '../../utils/nivelCliente.js'
import { validadorPermissaoElemento } from '../../utils/verificadorPermissaoElemento.js'
import ColetaClickstream from '../clickstreamAnalise/clickstreamColeta.js'
import BarraDadosCliente from '../componentesModais/barraDadosCliente/barraDadosCliente.js'
import BarraFiltragem from '../componentesModais/barraFiltragem/barraFiltragem.js'

import DashCardsRow from './components/DashCardsRow.jsx'
import GraficoSimcardsConsumoCiclo from './components/GraficoSimcardsConsumoCiclo.jsx'
import GraficoSimcardsOperadoras from './components/GraficoSimcardsOperadoras.jsx'
import GraficoSimcardsSemComunicar from './components/GraficoSimcardsSemComunicar.jsx'
import GraficoSimcardsStatus from './components/GraficoSimcardsStatus.jsx'
import GraficoStatusContrato from './components/GraficoStatusContrato.jsx'
import GraficoTecnologias from './components/GraficoTecnologias.jsx'
import LinhaLegenda from './components/LinhaLegenda.jsx'
import {
  RenderMenuOpcoesMapeado,
  RenderMenuOpcoesSimcardsStatus,
  RenderMenuOpcoesSimcardSemComunicar,
  RenderMenuOpcoesConsumo
} from './utils/menuUtils.jsx'

let arrayCores = []
if (decryptJWT('clientePrimario') == 2455) {
  arrayCores = [cor.verde, ...DashArrayCoresDefault]
} else {
  arrayCores = [cor.verdeClaro, ...DashArrayCoresDefault]
}

const getColorByIdx = (idx) => handleGetColorByIdx(arrayCores, idx)

function Dasboard(props) {
  const { setIsLoadingGlobal } = useGlobal()
  const despacho = useDispatch()

  let realizouFiltragem = useSelector(
    (state) => state.manejadorState.realizouFiltro
  )

  let recarregarBarraFiltragemValor = useSelector(
    (state) => state.filtrosState.recarregarBarraFiltragem
  )
  const permissaoElemento = useSelector(
    (state) => state.permissaoState.permissaoElemento
  )
  const { filtros } = useSelector((state) => state.filtrosState)

  const localTema = localStorage.getItem('tema')

  const [totalSimcards, setTotalSimcards] = useState(0)
  const [filtroOperadora, setFiltroOperadora] = useState(false)
  const [filtroOperadoraPlano, setFiltroOperadoraPlano] = useState(false)
  const [arrayConsumoTotal, setArrayConsumoTotal] = useState([])
  const [tooltipConsumoTotal, setTooltipConsumoTotal] = useState(0)
  const [percentualTotalContratado, setPercentualTotalContratado] = useState(0)
  const [percentualPrevisaoConsumo, setPercentualPrevisaoConsumo] = useState(0)
  const [percentualConsumoTotal, setPercentualConsumoTotal] = useState(0)
  const [percentualTotalAtivo, setPercentualTotalAtivo] = useState(0)
  const [tooltipTotalContratado, setTooltipTotalContratado] = useState(0)
  const [tooltipTotalAtivo, setTooltipTotalAtivo] = useState(0)
  const [tooltipPrevisaoConsumo, setTooltipPrevisaoConsumo] = useState(0)
  const [revelarOpcoesConsumo, setRevelarOpcoesConsumo] = useState(false)
  const [revelarOpcoesConexoes, setRevelarOpcoesConexoes] = useState(false)
  const [arraySimcardsStatus, setArraySimcardsStatus] = useState([])
  const [tooltipSimcardsStatus, setTooltipSimcardsStatus] = useState(0)
  const [revelarOpcoesSimcardsStatus, setRevelarOpcoesSimcardsStatus] =
    useState(false)
  const [tooltipSimcardsOnline, setTooltipSimcardsOnline] = useState(0)
  const [revelarOpcoesSimcardsOnline, setRevelarOpcoesSimcardsOnline] =
    useState(false)
  const [tooltipSimcardsOffline, setTooltipSimcardsOffline] = useState(0)
  const [revelarOpcoesSimcardsOffline, setRevelarOpcoesSimcardsOffline] =
    useState(false)
  const [arraySemComunicar24h, setArraySemComunicar24h] = useState([])
  const [tooltipSemComunicar24h, setTooltipSemComunicar24h] = useState(0)
  const [tooltipSemComunicar24h30d, setTooltipSemComunicar24h30d] = useState(0)
  const [tooltipSemComunicar30d60d, setTooltipSemComunicar30d60d] = useState(0)
  const [tooltipSemComunicar60d, setTooltipSemComunicar60d] = useState(0)
  const [tooltipSimcardsEmEstoque, setTooltipSimcardsEmEstoque] = useState(0)
  const [tooltipSimcardsSemComunicar, setTooltipSimcardsSemComunicar] =
    useState(0)
  const [
    revelarOpcoesSimcardsSemComunicar,
    setRevelarOpcoesSimcardsSemComunicar
  ] = useState(false)

  const [
    graficoTotalSimcardsOperadoraMax,
    setGraficoTotalSimcardsOperadoraMax
  ] = useState(0)
  const [graficoTotalSimcardsOperadora, setGraficoTotalSimcardsOperadora] =
    useState([])
  const [legendaTotalSimcardsOperadora, setLegendaTotalSimcardsOperadora] =
    useState([])
  const [dadosTotalSimcardsOperadora, setDadosTotalSimcardsOperadora] =
    useState()
  const [
    revelarOpcoesTotalSimcardsOperadora,
    setRevelarOpcoesTotalSimcardsOperadora
  ] = useState(false)
  const [graficoTotalTecnologias, setGraficoTotalTecnologias] = useState(0)
  const [
    graficoTotalTecnologiasIndividuais,
    setGraficoTotalTecnologiasIndividuais
  ] = useState([])
  const [legendaTotalTecnologias, setLegendaTotalTecnologias] = useState([])
  const [dadosTotalTecnologias, setDadosTotalTecnologias] = useState()
  const [revelarOpcoesTecnologias, setRevelarOpcoesTecnologias] =
    useState(false)
  const [graficoStatusContratoMax, setGraficoStatusContratoMax] = useState(0)
  const [graficoStatusContrato, setGraficoStatusContrato] = useState([])
  const [legendaStatusContrato, setLegendaStatusContrato] = useState([])
  const [dadosStatusContrato, setDadosStatusContrato] = useState()
  const [cdPlano, setCdPlano] = useState(null)
  const [consumoNoCicloDash, setConsumoNoCicloDash] = useState('default')
  const [showHistoricoConsumo, setShowHistoricoConsumo] = useState(false)
  const [dataHistoricoConsumo, setDataHistoricoConsumo] = useState([])
  const [labelDashboardConsumo, setLabelDashboardConsumo] =
    useState('Consumo nos ciclos')
  const [loadingDash, setLoadingDash] = useState(false)
  const [notHasSharedPlan, setNotHasSharedPlan] = useState(false)
  const [revelarOpcoesStatusContrato, setRevelarOpcoesStatusContrato] =
    useState(false)

  const [chartConsumoData, setChartConsumoData] = useState()
  const [chartFillColors, setChartFillColors] = useState()
  const [valueTotals, setValueTotals] = useState()

  const periodo = 0

  const [coletaUsabilidade, setColetaUsabilidade] = useState(true)

  const [
    openedAlertaSharedPlan,
    { open: openAlertaSharedPlan, close: closeAlertaSharedPlan }
  ] = useDisclosure(false)

  const cdClientePrimario = decryptJWT('clientePrimario')
  const clienteAlgar = cdClientePrimario == 2455
  const userHasPrivateNetworks = decryptJWT('userHasPrivateNetworks')

  const { getOperadoras } = DispositivosService

  const portalCliente = isPortal()

  let filtrosArrayBarraDados = useSelector(
    (state) => state.filtrosState.filtrosArrayBarra
  )

  useEffect(() => {
    despacho(mudarManejador('dashboardGeral'))

    if (props.revelarBarraFiltro === true) {
      despacho(revelarBarraFiltragem(false))
    }

    if (props.filtros.vazio != 'vazio') {
      despacho(mudarFiltros({ vazio: 'vazio' }))
      despacho(limpadorFiltros(true))
      despacho(revelarBarraFiltragem(false))
      despacho(filtrosArrayBarra([]))
    }

    return () => {
      setIsLoadingGlobal(false)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useQuery(
    ['dashboardData', periodo, filtros],
    async () => {
      setIsLoadingGlobal(true)

      let response

      if (!filtros.vazio) {
        const dados = { periodo, filtros }
        response = await api_gateway.post('/m1/filtrar/dashboard_todos', dados)
      } else {
        response = await api_gateway.get(
          `/m1/consultar/dashboard_todos?periodo=${periodo}`
        )
      }

      return response.data?.dados
    },
    {
      onSuccess: (dadosDash) => {
        if (!dadosDash) return

        if (realizouFiltragem) {
          despacho(realizouFiltro(false))
        }

        setCdPlano(
          !filtros?.OPERADORA_PLANO || filtros?.OPERADORA_PLANO === ''
            ? null
            : filtros?.OPERADORA_PLANO
        )

        /* SIM CARDS TOTAL */
        if (dadosDash?.n0_simcards_max !== undefined) {
          setTotalSimcards(dadosDash.n0_simcards_max)
        }

        /* SIM CARDS STATUS */
        if (
          dadosDash.n0_simcards_online === 0 &&
          dadosDash.n0_simcards_offline === 0 &&
          dadosDash.n0_simcards_em_estoque === 0
        ) {
          setArraySimcardsStatus([
            {
              value: 100,
              cor:
                localTema === 'claro' || localTema === 'algarClaro'
                  ? cor.cinza
                  : cor.cinzaEscuro
            }
          ])
        } else {
          setArraySimcardsStatus([
            { value: dadosDash.n0_simcards_online, cor: cor.verdeClaro },
            {
              value:
                dadosDash.n0_simcards_offline -
                dadosDash.n0_simcards_em_estoque,
              cor: cor.vermelho
            },
            { value: dadosDash.n0_simcards_em_estoque, cor: cor.azul }
          ])
        }

        setTooltipSimcardsStatus(dadosDash.n0_simcards_max)
        setTooltipSimcardsOnline(dadosDash.n0_simcards_online)
        setTooltipSimcardsOffline(
          dadosDash.n0_simcards_offline - dadosDash.n0_simcards_em_estoque
        )

        /* SIMCARDS SEM COMUNICAR */
        setArraySemComunicar24h([
          { value: dadosDash.n0_sem_comunicacao_24h, cor: cor.verdeClaro },
          { value: dadosDash.n0_sem_comunicacao_24h_30d, cor: cor.amarelo },
          { value: dadosDash.n0_sem_comunicacao_30d_60d, cor: cor.laranja },
          { value: dadosDash.n0_sem_comunicacao_60d, cor: cor.vermelho },
          { value: dadosDash.n0_simcards_em_estoque, cor: cor.azul }
        ])

        setTooltipSemComunicar24h(dadosDash.n0_sem_comunicacao_24h)
        setTooltipSemComunicar24h30d(dadosDash.n0_sem_comunicacao_24h_30d)
        setTooltipSemComunicar30d60d(dadosDash.n0_sem_comunicacao_30d_60d)
        setTooltipSemComunicar60d(dadosDash.n0_sem_comunicacao_60d)
        setTooltipSimcardsEmEstoque(dadosDash.n0_simcards_em_estoque)
        setTooltipSimcardsSemComunicar(
          dadosDash.n0_sem_comunicacao_24h +
            dadosDash.n0_sem_comunicacao_24h_30d +
            dadosDash.n0_sem_comunicacao_30d_60d +
            dadosDash.n0_sem_comunicacao_60d +
            dadosDash.n0_simcards_em_estoque
        )

        const formatarDados = (size) => {
          const fromUnit = 'MB'
          const toUnit = 'GB'
          if (size <= 1024) return `${formatarMilhar(size)} ${fromUnit}` // 1000 => '1.000,00 MB'
          return (
            formatarMilhar(ConversorBytes(size, fromUnit, toUnit)) +
            ' ' +
            toUnit
          ) // 10000 => '9,77 GB'
        }

        /* GRAFICOS DE CONSUMO */
        setTooltipTotalContratado(formatarDados(dadosDash.n2_planos_total))
        setTooltipTotalAtivo(formatarDados(dadosDash.n2_planos_total_ativo))
        setTooltipPrevisaoConsumo(formatarDados(dadosDash.n2_previsao_consumo))
        setTooltipConsumoTotal(formatarDados(dadosDash.n2_consumo_total))

        const getBarValue = (val) => {
          const perc = (val * 100) / dadosDash.n2_planos_total
          return perc > 0 && perc < 1 ? 1 : perc // para aparecer no gráfico de barras
        }

        const percPlanosTotalAtivo = getBarValue(
          dadosDash.n2_planos_total_ativo
        )
        const percConsumoTotal = getBarValue(dadosDash.n2_consumo_total)
        const percPlanosTotal = getBarValue(dadosDash.n2_planos_total)
        const percPrevisaoConsumo = getBarValue(dadosDash.n2_previsao_consumo)

        setPercentualConsumoTotal(percConsumoTotal)
        setPercentualTotalAtivo(percPlanosTotalAtivo)
        setPercentualPrevisaoConsumo(percPrevisaoConsumo)
        setPercentualTotalContratado(100)

        if (
          percPlanosTotalAtivo == 0 &&
          percConsumoTotal == 0 &&
          percPrevisaoConsumo == 0
        ) {
          setArrayConsumoTotal([{ value: percPlanosTotal, fill: cor.azul }])
        } else if (!filtros.OPERADORA || !filtros.OPERADORA_PLANO) {
          setArrayConsumoTotal([
            {
              value: percPlanosTotal,
              fill: cor.azul,
              percent: percentualTotalContratado
            },
            {
              value: percPlanosTotalAtivo,
              fill: cor.verdeClaro,
              percent: percentualTotalAtivo
            }
          ])
          setFiltroOperadora(false)
          setFiltroOperadoraPlano(false)
        } else {
          setArrayConsumoTotal([
            {
              value: percPlanosTotal,
              fill: cor.azul,
              percent: percentualTotalContratado
            },
            {
              value: percPlanosTotalAtivo,
              fill: cor.verdeClaro,
              percent: percentualTotalAtivo
            },
            {
              value: percPrevisaoConsumo,
              fill: cor.amarelo,
              percent: percentualPrevisaoConsumo
            },
            {
              value: percConsumoTotal,
              fill: cor.vermelho,
              percent: percentualConsumoTotal
            }
          ])
          setFiltroOperadora(true)
          setFiltroOperadoraPlano(true)
        }

        /* GRAFICOS DE OPERADORAS */
        setDadosTotalSimcardsOperadora(
          JSON.parse(JSON.stringify(dadosDash.operadoras))
        )

        /* GRAFICOS DE CONTRATOS */
        setDadosStatusContrato(JSON.parse(JSON.stringify(dadosDash.contratos)))

        /* CARD DE TOTAL DE OPERADORAS */
        if (dadosDash.operadoras.length !== 0) {
          const totalSimcardsOperadoras = JSON.parse(
            JSON.stringify(dadosDash.operadoras)
          )
          let quantidadeOperadoras = totalSimcardsOperadoras.length
          let arrayGraficosTotalSimcardsOperadora = []
          let contadorRenderTotalSimcardsOperadora = 0
          let manejadorLabel = ''
          for (let y = 0; y < quantidadeOperadoras; y++) {
            if (
              totalSimcardsOperadoras[contadorRenderTotalSimcardsOperadora] !=
              undefined
            ) {
              manejadorLabel =
                totalSimcardsOperadoras[contadorRenderTotalSimcardsOperadora]
                  .label
              arrayGraficosTotalSimcardsOperadora.push({
                value:
                  totalSimcardsOperadoras[contadorRenderTotalSimcardsOperadora]
                    .quantidade,
                cor: getColorByIdx(contadorRenderTotalSimcardsOperadora),
                label:
                  manejadorLabel.slice(0, 1).toUpperCase() +
                  manejadorLabel.slice(1, manejadorLabel.length).toLowerCase()
              })
              contadorRenderTotalSimcardsOperadora++
            }
          }
          let objetoLegendaTotalSimcardsOperadora =
            arrayGraficosTotalSimcardsOperadora.map((itemContrato) => {
              return (
                <LinhaLegenda
                  key={itemContrato.label}
                  itemContrato={itemContrato}
                  clienteAlgar={clienteAlgar}
                />
              )
            })
          setGraficoTotalSimcardsOperadoraMax(dadosDash.n0_simcards_max)
          setGraficoTotalSimcardsOperadora(
            JSON.parse(JSON.stringify(arrayGraficosTotalSimcardsOperadora))
          )
          setLegendaTotalSimcardsOperadora(objetoLegendaTotalSimcardsOperadora)
        } else {
          let arrayGraficosTotalSimcardsOperadora = [
            {
              cor:
                localTema === 'claro' || localTema === 'algarClaro'
                  ? cor.cinza
                  : cor.cinzaEscuro,
              label: 'Vazio',
              value: 0
            }
          ]
          let objetoLegendaTotalSimcardsOperadora =
            arrayGraficosTotalSimcardsOperadora.map((itemContrato, idx) => {
              return <LinhaLegenda key={idx} itemContrato={itemContrato} />
            })
          setGraficoTotalSimcardsOperadoraMax(0)
          setGraficoTotalSimcardsOperadora([
            {
              cor:
                localTema === 'claro' || localTema === 'algarClaro'
                  ? cor.cinza
                  : cor.cinzaEscuro,
              value: 100
            }
          ])
          setLegendaTotalSimcardsOperadora(objetoLegendaTotalSimcardsOperadora)
        }

        /*CARD TECNOLOGIAS */
        if (dadosDash.tecnologias.length !== 0) {
          const totalTecnologias = JSON.parse(
            JSON.stringify(dadosDash.tecnologias)
          )
          let quantidadeTecnologias = totalTecnologias.length
          let totalLable = 0
          let arrayGraficosTecnologias = []
          let contadorRenderTecnologias = 0
          let manejadorLabel = ''
          for (let y = 0; y < quantidadeTecnologias; y++) {
            if (totalTecnologias[contadorRenderTecnologias] != undefined) {
              manejadorLabel = totalTecnologias[contadorRenderTecnologias].label
              if (manejadorLabel == 'OUTRAS') {
                manejadorLabel =
                  manejadorLabel.slice(0, 1).toUpperCase() +
                  manejadorLabel.slice(1, manejadorLabel.length).toLowerCase()
              } else if (manejadorLabel == 'NB') {
                manejadorLabel = manejadorLabel.toUpperCase() + '-IoT'
              } else {
                manejadorLabel =
                  manejadorLabel.slice(0, 1).toUpperCase() +
                  manejadorLabel.slice(1, manejadorLabel.length)
              }
              arrayGraficosTecnologias.push({
                value: totalTecnologias[contadorRenderTecnologias].quantidade,
                cor: getColorByIdx(contadorRenderTecnologias),
                label: manejadorLabel
              })
              totalLable +=
                totalTecnologias[contadorRenderTecnologias].quantidade
              contadorRenderTecnologias++
            }
          }
          let objetoLegendaTecnologias = arrayGraficosTecnologias.map(
            (itemContrato, idx) => {
              return (
                <LinhaLegenda
                  key={idx}
                  itemContrato={itemContrato}
                  clienteAlgar={clienteAlgar}
                />
              )
            }
          )
          setGraficoTotalTecnologias(totalLable)
          setGraficoTotalTecnologiasIndividuais(
            JSON.parse(JSON.stringify(arrayGraficosTecnologias))
          )
          setLegendaTotalTecnologias(objetoLegendaTecnologias)
        } else {
          let arrayGraficosTecnologias = [
            {
              cor:
                localTema === 'claro' || localTema === 'algarClaro'
                  ? cor.cinza
                  : cor.cinzaEscuro,
              label: 'Vazio',
              value: 0
            }
          ]
          let objetoLegendaTecnologias = arrayGraficosTecnologias.map(
            (itemContrato, idx) => {
              return <LinhaLegenda key={idx} itemContrato={itemContrato} />
            }
          )
          setGraficoTotalTecnologias(0)
          setGraficoTotalTecnologiasIndividuais([
            {
              cor:
                localTema === 'claro' || localTema === 'algarClaro'
                  ? cor.cinza
                  : cor.cinzaEscuro,
              value: 100
            }
          ])
          setLegendaTotalTecnologias(objetoLegendaTecnologias)
        }

        setDadosTotalTecnologias(
          JSON.parse(JSON.stringify(dadosDash.tecnologias))
        )

        /* CARD DE STATUS DO CONTRATO */
        if (dadosDash.contratos.length !== 0) {
          const statusContratos = JSON.parse(
            JSON.stringify(dadosDash.contratos)
          )
          let quantidadeContratos = statusContratos.length
          let arrayGraficosStatusContrato = []
          let contadorRenderStatusContrato = 0
          let manejadorLabel = ''
          for (let y = 0; y < quantidadeContratos; y++) {
            if (statusContratos[contadorRenderStatusContrato] != undefined) {
              manejadorLabel =
                statusContratos[contadorRenderStatusContrato].label
              if (manejadorLabel == 0 || manejadorLabel == undefined) {
                manejadorLabel = 'INDISPONÍVEL'
                arrayGraficosStatusContrato.push({
                  label:
                    manejadorLabel.slice(0, 1).toUpperCase() +
                    manejadorLabel.slice(1, manejadorLabel.length).toLowerCase()
                })
              } else {
                if (manejadorLabel === 'DEMONSTRACAO') {
                  manejadorLabel = 'Demonstração'
                }
                arrayGraficosStatusContrato.push({
                  value:
                    statusContratos[contadorRenderStatusContrato].quantidade,
                  cor: getColorByIdx(contadorRenderStatusContrato),
                  label:
                    manejadorLabel.slice(0, 1).toUpperCase() +
                    manejadorLabel.slice(1, manejadorLabel.length).toLowerCase()
                })
                contadorRenderStatusContrato++
              }
            }
          }
          let objetoLegendaStatusContrato = arrayGraficosStatusContrato.map(
            (itemContrato, idx) => {
              return (
                <div className="linha-legenda-status-contrato" key={idx}>
                  <div className="coluna-legenda-status-contrato-1">
                    <div
                      className="esfera-legenda-dashboard"
                      style={{ backgroundColor: itemContrato.cor }}
                    />
                  </div>
                  <div className="coluna-legenda-status-contrato-2">
                    <span className="fonte-cor-1 texto-legenda-status-contrato">
                      {itemContrato.label}
                    </span>
                  </div>
                  <div className="coluna-legenda-status-contrato-3">
                    <span className="fonte-cor-1 texto-legenda-status-contrato-numero">
                      {formatarMilharSemDecimais(itemContrato.value)}
                    </span>
                  </div>
                </div>
              )
            }
          )
          setGraficoStatusContratoMax(dadosDash.n0_simcards_max)
          setGraficoStatusContrato(
            JSON.parse(JSON.stringify(arrayGraficosStatusContrato))
          )
          setLegendaStatusContrato(objetoLegendaStatusContrato)
        } else {
          let arrayGraficosStatusContrato = [
            {
              cor:
                localTema === 'claro' || localTema === 'algarClaro'
                  ? cor.cinza
                  : cor.cinzaEscuro,
              label: 'Vazio',
              value: 0
            }
          ]
          let objetoLegendaStatusContrato = arrayGraficosStatusContrato.map(
            (itemContrato, idx) => {
              return (
                <div className="linha-legenda-status-contrato" key={idx}>
                  <div className="coluna-legenda-status-contrato-1">
                    <div
                      className="esfera-legenda-dashboard"
                      style={{ backgroundColor: itemContrato.cor }}
                    />
                  </div>
                  <div className="coluna-legenda-status-contrato-2">
                    <span className="fonte-cor-1 texto-legenda-status-contrato">
                      {itemContrato.label}
                    </span>
                  </div>
                  <div className="coluna-legenda-status-contrato-3">
                    <span className="fonte-cor-1 texto-legenda-status-contrato-numero">
                      {formatarMilharSemDecimais(itemContrato.value)}
                    </span>
                  </div>
                </div>
              )
            }
          )
          setGraficoStatusContratoMax(0)
          setGraficoStatusContrato([
            {
              cor:
                localTema === 'claro' || localTema === 'algarClaro'
                  ? cor.cinza
                  : cor.cinzaEscuro,
              value: 100
            }
          ])
          setLegendaStatusContrato(objetoLegendaStatusContrato)
        }

        setIsLoadingGlobal(false)
      },
      onError: (error) => {
        setIsLoadingGlobal(false)
        console.error(error)
      },
      keepPreviousData: false,
      refetchOnWindowFocus: false
    }
  )

  useEffect(() => {
    setConsumoNoCicloDash('default')
    const fetchData = async () => {
      const nomeOperadora = filtrosArrayBarraDados
        ?.find((str) => str.includes('Operadora'))
        ?.match(/Operadora:\s*(.*?)\?/i)?.[1]
        ?.toLowerCase()

      const { data } = await api_gateway.get('/m1/consultar/operadora')
      const operadoraData = data.dados.find(
        (e) => e.ds_dsp_operadora.toLowerCase() == nomeOperadora
      )

      const { data: dashConsumo } = await api_gateway
        .get(
          `/api/v2/dashboards/shared/plan/consumption?operadora=${operadoraData?.cd_dsp_operadora}&operadoraPlano=${cdPlano}`
        )
        .finally(() => {
          setLoadingDash(false)
        })

      setNotHasSharedPlan(
        'notHasSharedPlan' in dashConsumo && dashConsumo?.notHasSharedPlan
          ? true
          : false
      )
      if (dashConsumo?.length) setDataHistoricoConsumo(dashConsumo)
    }

    if (cdPlano) {
      setShowHistoricoConsumo(true)
      setLoadingDash(true)
      fetchData()
    } else {
      setShowHistoricoConsumo(false)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [cdPlano])

  useEffect(() => {
    if (coletaUsabilidade) {
      ColetaClickstream(525) // 'painelDashboardDashboard'
      setColetaUsabilidade(false)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  /* CONTROLA O CLICK FORA DOS MENUS DE OPCOES ( três pontinho verdes ) */
  function handleAbrirMenuOpcoes(identificador) {
    switch (identificador) {
      case 'consumo':
        setRevelarOpcoesConsumo(!revelarOpcoesConsumo)
        break
      case 'conexoes':
        setRevelarOpcoesConexoes(!revelarOpcoesConexoes)
        break
      case 'simcardsStatus':
        setRevelarOpcoesSimcardsStatus(!revelarOpcoesSimcardsStatus)
        break
      case 'simcardsOnline':
        setRevelarOpcoesSimcardsOnline(!revelarOpcoesSimcardsOnline)
        break
      case 'simcardsOffline':
        setRevelarOpcoesSimcardsOffline(!revelarOpcoesSimcardsOffline)
        break
      case 'simcardsSemComnuicar':
        setRevelarOpcoesSimcardsSemComunicar(!revelarOpcoesSimcardsSemComunicar)
        break
      case 'simcardsOperadoras':
        setRevelarOpcoesTotalSimcardsOperadora(
          !revelarOpcoesTotalSimcardsOperadora
        )
        break
      case 'statusContrato':
        setRevelarOpcoesStatusContrato(!revelarOpcoesStatusContrato)
        break
      case 'tecnologias':
        setRevelarOpcoesTecnologias(!revelarOpcoesTecnologias)
        break
    }
  }

  /* CONTROLA A EXPANSAO E CONTRACAO DOS DROPDOWNS DOS MENUS DE OPCOES */
  function dropMenuOpcoes(event, elementoId, imagemId) {
    let elemento = document.getElementById(elementoId)
    let imagem = document.getElementById(imagemId)

    if (imagem.classList.contains('menu-opcoes-icone-desativado')) {
      imagem.classList.remove('menu-opcoes-icone-desativado')
      imagem.classList.add('menu-opcoes-icone-ativado')
    } else if (imagem.classList.contains('menu-opcoes-icone-ativado')) {
      imagem.classList.remove('menu-opcoes-icone-ativado')
      imagem.classList.add('menu-opcoes-icone-desativado')
    }

    if (elemento.classList.contains('dropdown-desativado')) {
      elemento.classList.remove('dropdown-desativado')
      elemento.classList.add('dropdown-ativado')
    } else if (elemento.classList.contains('dropdown-ativado')) {
      elemento.classList.remove('dropdown-ativado')
      elemento.classList.add('dropdown-desativado')
    }
  }

  // Função criada para auxiliar o filtro por
  // status do contrato (que usa %like% e pega ativo e pre-ativo na busca)
  function tratarString(str1) {
    str1 = str1.toLowerCase()
    const firstLetterUpper = str1.substr(0, 1).toUpperCase()
    const strRest = str1.substr(1, str1.length - 1)
    return firstLetterUpper + strRest
  }

  /* Mostra em dispositivos o que foi selecionado no menu-drop-down (3 pontinhos verdes) */
  async function mostrarEmDispositivos(filtro) {
    let auxFiltros = { ...filtro }

    const auxBarraFiltros = []

    const statusMap = {
      online: 'Online',
      estoque: 'Estoque',
      ultima_conexao: 'Offline'
    }

    const status = statusMap[filtro.ULTIMA_CONEXAO]
    if (status) {
      auxBarraFiltros.push(`Status: ${status}?ULTIMA_CONEXAO`)
    }

    const mensagens = {
      sem_comunicacao_24h: '24 horas',
      sem_comunicacao_24h_30d: 'Entre 24 horas e 30 dias',
      sem_comunicacao_30d_60d: 'Entre 30 e 60 dias',
      sem_comunicacao_60d: 'Mais de 60 dias'
    }

    const mensagem = mensagens[filtro.SEM_COMUNICAR]
    if (mensagem) {
      auxBarraFiltros.push(`Sem comunicar: ${mensagem}?SEM_COMUNICAR`)
    }

    const filtrosOperadora = filtros.OPERADORA || filtro.OPERADORA
    if (filtrosOperadora) {
      try {
        setIsLoadingGlobal(true)

        const data = await getOperadoras()
        const operadorasData = data?.dados || data || []

        const operadoraSelecionada = operadorasData.find(
          (op) =>
            op.ds_dsp_operadora === filtrosOperadora ||
            op.cd_dsp_operadora === Number(filtrosOperadora)
        )

        if (operadoraSelecionada?.ds_dsp_operadora) {
          auxBarraFiltros.push(
            `${operadoraSelecionada.ds_dsp_operadora} ${operadoraSelecionada.cd_dsp_operadora}`
          )

          auxFiltros = {
            ...auxFiltros,
            OPERADORA: String(operadoraSelecionada.cd_dsp_operadora)
          }
        }
        setIsLoadingGlobal(false)
      } catch (error) {
        setIsLoadingGlobal(false)
        console.error('Erro ao buscar operadoras:', error)
      }
    }

    if (filtros.DS_GRUPO && filtros.GRUPO) {
      auxBarraFiltros.push(`${filtros.DS_GRUPO}?GRUPO`)
      auxFiltros = {
        ...auxFiltros,
        GRUPO: Number(filtros.GRUPO)
      }
    }

    if (filtros.OPERADORA_PLANO) {
      auxBarraFiltros.push(`Operadora Plano: ${filtros.DS_OPERADORA_PLANO}`)

      auxFiltros = {
        ...auxFiltros,
        OPERADORA_PLANO: Number(filtros.OPERADORA_PLANO)
      }
    }

    if (filtro.STATUS_CONTRATO) {
      const strStatusContrato = tratarString(filtro.STATUS_CONTRATO)
      auxBarraFiltros.push(
        `Situação do contrato: ${strStatusContrato}?STATUS_CONTRATO`
      )
    }

    if (filtro.PLANO) {
      auxBarraFiltros.push(`Plano: ${filtro.PLANO} MB?PLANO`)
    }

    if (filtro.TECNOLOGIA) {
      let strTecnologia = filtro.TECNOLOGIA
      if (strTecnologia === 'OUTRAS') strTecnologia = 'Outras'
      if (strTecnologia === 'NB') strTecnologia = 'NB-IoT'
      auxBarraFiltros.push(`Tecnologia: ${strTecnologia}?TECNOLOGIA`)
    }

    despacho(mudarFiltros(auxFiltros))

    if (auxBarraFiltros.length > 0) {
      despacho(filtrosArrayBarra(auxBarraFiltros))
    }
    setIsLoadingGlobal(false)

    despacho(revelarBarraFiltragem(true))
    despacho(limpadorFiltros(false))
    despacho(recarregarBarraFiltragem(!recarregarBarraFiltragemValor))
    despacho(mudarManejador('dspDispositivos'))
  }

  //gabiarra para redirecionar para a dash de faturas caso o cliente possua apenas o modulo faturas
  useEffect(() => {
    handleVerificarPermissao()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [permissaoElemento])

  async function handleVerificarPermissao() {
    ColetaClickstream(526) // 'painelDashboardDashboardHandleVerificarPermissao'
    const permissaoDispositivos = await validadorPermissaoElemento(
      permissaoElemento,
      'veye/dashboard/dispositivos'
    )
    const permissaoFaturas = await validadorPermissaoElemento(
      permissaoElemento,
      'veye/dashboard/faturas'
    )
    if (permissaoDispositivos === false && permissaoFaturas === true) {
      props.history.push('/veye/faturas/dashboard')
    }
  }

  useEffect(() => {
    prepareChartData()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [arrayConsumoTotal])

  function prepareChartData() {
    let dataChart = [
      {
        value: percentualTotalContratado,
        fill: cor.azul,
        label: 'Total contratado'
      },
      {
        value: percentualTotalAtivo,
        fill: cor.verdeClaro,
        label: 'Total ativo'
      },
      {
        value: percentualPrevisaoConsumo,
        fill: cor.amarelo,
        label: 'Previsão de consumo'
      },
      {
        value: percentualConsumoTotal,
        fill: cor.vermelho,
        label: 'Consumo total'
      }
    ]
    let chartDataFillColors = []
    let chartData = []
    let chartValueTotals = [
      { data: tooltipTotalContratado },
      { data: tooltipTotalAtivo },
      { data: tooltipPrevisaoConsumo },
      { data: tooltipConsumoTotal }
    ]
    setValueTotals(chartValueTotals)

    chartDataFillColors = [
      ...dataChart.map((item) => {
        return item.fill
      })
    ]
    setChartFillColors(chartDataFillColors)

    dataChart.forEach((item) => {
      chartData.push({
        name: item.label,
        data: [
          {
            x: item.label,
            y: item.value
          }
        ]
      })
    })
    setChartConsumoData(chartData)
  }

  return (
    <div className="container-dashboard-tela">
      <BarraDadosCliente />
      <BarraFiltragem revelarBarraFiltro={props.revelarBarraFiltro} />

      <DashCardsRow revelarBarraFiltro={props.revelarBarraFiltro}>
        <GraficoSimcardsStatus
          totalSimcards={totalSimcards}
          portalCliente={portalCliente}
          handleAbrirMenuOpcoes={handleAbrirMenuOpcoes}
          revelarOpcoesSimcardsStatus={revelarOpcoesSimcardsStatus}
          menuElement={
            <RenderMenuOpcoesSimcardsStatus
              tipo="online"
              exportar="exportarSimcardsStatus"
              setRevelarOpcoesSimcardsStatus={setRevelarOpcoesSimcardsStatus}
              revelarOpcoesSimcardsStatus={revelarOpcoesSimcardsStatus}
              mostrarEmDispositivos={mostrarEmDispositivos}
              dropMenuOpcoes={dropMenuOpcoes}
            />
          }
          arraySimcardsStatus={arraySimcardsStatus}
          tooltipSimcardsStatus={tooltipSimcardsStatus}
          tooltipSimcardsOnline={tooltipSimcardsOnline}
          tooltipSimcardsOffline={tooltipSimcardsOffline}
          tooltipSimcardsEmEstoque={tooltipSimcardsEmEstoque}
        />
        <GraficoSimcardsSemComunicar
          portalCliente={portalCliente}
          handleAbrirMenuOpcoes={handleAbrirMenuOpcoes}
          revelarOpcoesSimcardsSemComunicar={revelarOpcoesSimcardsSemComunicar}
          menuElement={
            <RenderMenuOpcoesSimcardSemComunicar
              setRevelarOpcoesSimcardsSemComunicar={
                setRevelarOpcoesSimcardsSemComunicar
              }
              revelarOpcoesSimcardsSemComunicar={
                revelarOpcoesSimcardsSemComunicar
              }
              exportar="exportarSimcardsSemComunicar"
              mostrarEmDispositivos={mostrarEmDispositivos}
              dropMenuOpcoes={dropMenuOpcoes}
            />
          }
          totalSimcards={totalSimcards}
          arraySemComunicar24h={arraySemComunicar24h}
          tooltipSimcardsSemComunicar={tooltipSimcardsSemComunicar}
          tooltipSemComunicar24h={tooltipSemComunicar24h}
          tooltipSemComunicar24h30d={tooltipSemComunicar24h30d}
          tooltipSemComunicar30d60d={tooltipSemComunicar30d60d}
          tooltipSemComunicar60d={tooltipSemComunicar60d}
          tooltipSimcardsEmEstoque={tooltipSimcardsEmEstoque}
        />

        {portalCliente ? (
          <GraficoSimcardsOperadoras
            totalSimcards={totalSimcards}
            portalCliente={portalCliente}
            handleAbrirMenuOpcoes={handleAbrirMenuOpcoes}
            revelarOpcoesTotalSimcardsOperadora={
              revelarOpcoesTotalSimcardsOperadora
            }
            menuElement={
              <RenderMenuOpcoesMapeado
                setRevelarOpcoesTotalSimcardsOperadora={
                  setRevelarOpcoesTotalSimcardsOperadora
                }
                revelarOpcoesTotalSimcardsOperadora={
                  revelarOpcoesTotalSimcardsOperadora
                }
                mostrarEmDispositivos={mostrarEmDispositivos}
                dropMenuOpcoes={dropMenuOpcoes}
                arrayJSON={dadosTotalSimcardsOperadora}
                campo="operadoras"
                exportar="exportarOperadoras"
              />
            }
            graficoTotalSimcardsOperadora={graficoTotalSimcardsOperadora}
            graficoTotalSimcardsOperadoraMax={graficoTotalSimcardsOperadoraMax}
            legendaTotalSimcardsOperadora={legendaTotalSimcardsOperadora}
          />
        ) : (
          <GraficoSimcardsConsumoCiclo
            arrayConsumoTotal={arrayConsumoTotal}
            portalCliente={portalCliente}
            handleAbrirMenuOpcoes={handleAbrirMenuOpcoes}
            revelarOpcoesConsumo={revelarOpcoesConsumo}
            menuElement={
              <RenderMenuOpcoesConsumo
                setRevelarOpcoesConsumo={setRevelarOpcoesConsumo}
                revelarOpcoesConsumo={revelarOpcoesConsumo}
                exportar="exportarConsumo"
                dropMenuOpcoes={dropMenuOpcoes}
                showHistoricoConsumo={cdPlano && showHistoricoConsumo}
                setConsumoNoCicloDash={setConsumoNoCicloDash}
                setLabelDashboardConsumo={setLabelDashboardConsumo}
                notHasSharedPlan={notHasSharedPlan}
                openAlertaSharedPlan={openAlertaSharedPlan}
                consumoNoCicloDash={consumoNoCicloDash}
              />
            }
            labelDashboardConsumo={labelDashboardConsumo}
            openedAlertaSharedPlan={openedAlertaSharedPlan}
            closeAlertaSharedPlan={closeAlertaSharedPlan}
            cdPlano={cdPlano}
            showHistoricoConsumo={showHistoricoConsumo}
            chartConsumoData={chartConsumoData}
            chartFillColors={chartFillColors}
            valueTotals={valueTotals}
            consumoNoCicloDash={consumoNoCicloDash}
            setConsumoNoCicloDash={setConsumoNoCicloDash}
            setLabelDashboardConsumo={setLabelDashboardConsumo}
            notHasSharedPlan={notHasSharedPlan}
            openAlertaSharedPlan={openAlertaSharedPlan}
            loadingDash={loadingDash}
            dataHistoricoConsumo={dataHistoricoConsumo}
            tooltipTotalContratado={tooltipTotalContratado}
            tooltipTotalAtivo={tooltipTotalAtivo}
            tooltipPrevisaoConsumo={tooltipPrevisaoConsumo}
            tooltipConsumoTotal={tooltipConsumoTotal}
            filtroOperadora={filtroOperadora}
            filtroOperadoraPlano={filtroOperadoraPlano}
            setRevelarOpcoesConsumo={setRevelarOpcoesConsumo}
          />
        )}
      </DashCardsRow>
      {!userHasPrivateNetworks && (
        <DashCardsRow revelarBarraFiltro={props.revelarBarraFiltro}>
          {portalCliente ? (
            <GraficoSimcardsConsumoCiclo
              arrayConsumoTotal={arrayConsumoTotal}
              portalCliente={portalCliente}
              handleAbrirMenuOpcoes={handleAbrirMenuOpcoes}
              revelarOpcoesConsumo={revelarOpcoesConsumo}
              menuElement={
                <RenderMenuOpcoesConsumo
                  setRevelarOpcoesConsumo={setRevelarOpcoesConsumo}
                  revelarOpcoesConsumo={revelarOpcoesConsumo}
                  exportar="exportarConsumo"
                  dropMenuOpcoes={dropMenuOpcoes}
                  showHistoricoConsumo={cdPlano && showHistoricoConsumo}
                  setConsumoNoCicloDash={setConsumoNoCicloDash}
                  setLabelDashboardConsumo={setLabelDashboardConsumo}
                  notHasSharedPlan={notHasSharedPlan}
                  openAlertaSharedPlan={openAlertaSharedPlan}
                  consumoNoCicloDash={consumoNoCicloDash}
                />
              }
              labelDashboardConsumo={labelDashboardConsumo}
              openedAlertaSharedPlan={openedAlertaSharedPlan}
              closeAlertaSharedPlan={closeAlertaSharedPlan}
              cdPlano={cdPlano}
              showHistoricoConsumo={showHistoricoConsumo}
              chartConsumoData={chartConsumoData}
              chartFillColors={chartFillColors}
              valueTotals={valueTotals}
              consumoNoCicloDash={consumoNoCicloDash}
              setConsumoNoCicloDash={setConsumoNoCicloDash}
              setLabelDashboardConsumo={setLabelDashboardConsumo}
              notHasSharedPlan={notHasSharedPlan}
              openAlertaSharedPlan={openAlertaSharedPlan}
              loadingDash={loadingDash}
              dataHistoricoConsumo={dataHistoricoConsumo}
              tooltipTotalContratado={tooltipTotalContratado}
              tooltipTotalAtivo={tooltipTotalAtivo}
              tooltipPrevisaoConsumo={tooltipPrevisaoConsumo}
              tooltipConsumoTotal={tooltipConsumoTotal}
              filtroOperadora={filtroOperadora}
              filtroOperadoraPlano={filtroOperadoraPlano}
              setRevelarOpcoesConsumo={setRevelarOpcoesConsumo}
            />
          ) : (
            <GraficoSimcardsOperadoras
              totalSimcards={totalSimcards}
              portalCliente={portalCliente}
              handleAbrirMenuOpcoes={handleAbrirMenuOpcoes}
              revelarOpcoesTotalSimcardsOperadora={
                revelarOpcoesTotalSimcardsOperadora
              }
              menuElement={
                <RenderMenuOpcoesMapeado
                  setRevelarOpcoesTotalSimcardsOperadora={
                    setRevelarOpcoesTotalSimcardsOperadora
                  }
                  revelarOpcoesTotalSimcardsOperadora={
                    revelarOpcoesTotalSimcardsOperadora
                  }
                  mostrarEmDispositivos={mostrarEmDispositivos}
                  dropMenuOpcoes={dropMenuOpcoes}
                  arrayJSON={dadosTotalSimcardsOperadora}
                  campo="operadoras"
                  exportar="exportarOperadoras"
                />
              }
              graficoTotalSimcardsOperadora={graficoTotalSimcardsOperadora}
              graficoTotalSimcardsOperadoraMax={
                graficoTotalSimcardsOperadoraMax
              }
              legendaTotalSimcardsOperadora={legendaTotalSimcardsOperadora}
            />
          )}

          <GraficoTecnologias
            portalCliente={portalCliente}
            handleAbrirMenuOpcoes={handleAbrirMenuOpcoes}
            revelarOpcoesTecnologias={revelarOpcoesTecnologias}
            menuElement={
              <RenderMenuOpcoesMapeado
                setRevelarOpcoesTecnologias={setRevelarOpcoesTecnologias}
                revelarOpcoesTecnologias={revelarOpcoesTecnologias}
                mostrarEmDispositivos={mostrarEmDispositivos}
                dropMenuOpcoes={dropMenuOpcoes}
                arrayJSON={dadosTotalTecnologias}
                campo="tecnologias"
                exportar="exportarTecnologias"
              />
            }
            graficoTotalTecnologiasIndividuais={
              graficoTotalTecnologiasIndividuais
            }
            graficoTotalTecnologias={graficoTotalTecnologias}
            legendaTotalTecnologias={legendaTotalTecnologias}
          />

          {!portalCliente && (
            <GraficoStatusContrato
              totalSimcards={totalSimcards}
              portalCliente={portalCliente}
              handleAbrirMenuOpcoes={handleAbrirMenuOpcoes}
              revelarOpcoesStatusContrato={revelarOpcoesStatusContrato}
              menuElement={
                <RenderMenuOpcoesMapeado
                  setRevelarOpcoesStatusContrato={
                    setRevelarOpcoesStatusContrato
                  }
                  revelarOpcoesStatusContrato={revelarOpcoesStatusContrato}
                  mostrarEmDispositivos={mostrarEmDispositivos}
                  dropMenuOpcoes={dropMenuOpcoes}
                  arrayJSON={dadosStatusContrato}
                  campo="contratos"
                  exportar="exportarStatusDeContrato"
                />
              }
              graficoStatusContrato={graficoStatusContrato}
              graficoStatusContratoMax={graficoStatusContratoMax}
              legendaStatusContrato={legendaStatusContrato}
            />
          )}
        </DashCardsRow>
      )}
    </div>
  )
}

function mapStateToProps(state) {
  return {
    conteudoBusca: state.manejadorState.conteudoBusca,
    filtros: state.filtrosState.filtros,
    revelarBarraFiltro: state.filtrosState.revelarBarraFiltragem
  }
}

export default withRouter(connect(mapStateToProps)(memo(Dasboard)))
